import { Suspense } from 'react';
import { useNoteWindows } from '@/contexts/NoteWindowsContext';
import { lazyModule } from '@/lib/lazyModule';

// Lazy: the window body pulls in the tiptap editor, which must not land in the
// bundle every page pays for. Nothing loads until a note window exists.
const NoteWindowLayer = lazyModule(() => import('./NoteWindowLayer'));

export function NoteWindowsMount() {
  const { windows } = useNoteWindows();
  if (windows.length === 0) return null;

  return (
    <Suspense fallback={null}>
      <NoteWindowLayer />
    </Suspense>
  );
}
